// frontend/src/components/common/dateStringUtils.js
//
// String <-> Date conversions and the day-bounds rule shared by
// AppDatePicker, AppDateRangePicker, and any caller that traffics in
// 'YYYY-MM-DD' wire strings. Kept out of the component files so they only
// export components (react-refresh/only-export-components — HMR boundary).

import { parseISO, format as fnsFormat } from 'date-fns';

export const dateStringToDate = (str) => (str ? parseISO(str) : null);

// A picker prop ('YYYY-MM-DD', a Date, or empty) as a Date, or undefined.
export const asDate = (v) => {
  if (v == null) return undefined;
  if (typeof v === 'string') return dateStringToDate(v) || undefined;
  return v;
};

export const dateToString = (date) => {
  if (!date || isNaN(date.getTime())) return '';
  return fnsFormat(date, 'yyyy-MM-dd');
};

// Whether a picked day is a real day within the optional min–max bounds.
export const dayInRange = (date, min, max) => {
  if (!date || isNaN(date.getTime())) return false;
  if (min && date < min) return false;
  if (max && date > max) return false;
  return true;
};
